import { SET_COMPONENT_SETTINGS, SetComponentSettings, Settings } from '../types/cta-download-app'

export const setComponentSettings = (value: Settings): SetComponentSettings => {
  return {
    type: SET_COMPONENT_SETTINGS,
    payload: value,
  }
}
